var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompare = function SvgCompare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.667 2.666 2 2-2 2M2.667 4.666H12M4.667 13.334l-2-2 2-2M12.666 11.334H3.333",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgCompare as ReactComponent };
export default "data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M10.667 2.66602L12.667 4.66602L10.667 6.66602' stroke='inherit' stroke-linecap='round' stroke-linejoin='round'/%3E %3Cpath d='M2.66699 4.66602H12.0003' stroke='inherit' stroke-linecap='round' stroke-linejoin='round'/%3E %3Cpath d='M4.66699 13.334L2.66699 11.334L4.66699 9.33398' stroke='inherit' stroke-linecap='round' stroke-linejoin='round'/%3E %3Cpath d='M12.6663 11.334H3.33301' stroke='inherit' stroke-linecap='round' stroke-linejoin='round'/%3E %3C/svg%3E";